module.exports = __webpack_public_path__ + "img/characteristic-1.29b9f673.png";